import React, { useState,useEffect,useRef, useContext } from "react";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import withStyles from '@mui/styles/withStyles';

import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';


import Popover from '@mui/material/Popover';

import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from 'axios'


const StyledMenu = withStyles({
    paper: {
      border: '1px solid #d3d4d5',
    },
  })((props) => (
    <Menu
      elevation={10}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      {...props}
    />
  ));
  

function ConnectedSeller(props) {

    const listElement = useRef();
    const popoverMenuParent = useRef();
    
    const [sellers,setSellers] = useState([]);
    const [popoverAnchorEl, setPopoverAnchorEl] = useState(null);
    const [isLoading,setIsLoading] = useState(true)


    const openPopoverMenu = Boolean(popoverAnchorEl);

    const [openConnectionDialog, setOpenConnectionDialog] = React.useState(false);
    
    const handleClose = () => {
        setPopoverAnchorEl(null);
        
    };
    const itemOnClick = (event)=>{
        setPopoverAnchorEl(event.currentTarget);
        
    }

    const handleClickOpenConnectionDialog = () => {
        setOpenConnectionDialog(true);
      };
    
    const handleCloseConnectionDialog = () => {
        setOpenConnectionDialog(false);
    };

    const requestForConnectionClickEvent = ()=>{
        handleClose()
        setOpenConnectionDialog(true)
    }

    const popupOver = ()=>{
        return (
            <Popover
                open={openPopoverMenu}
                anchorEl={popoverAnchorEl}
                onClose={handleClose}
                anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
                }}
                transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
                }}
                TransitionProps={{
                    onEntering: ()=>{
                        popoverMenuParent.current.style.width = (listElement.current.clientWidth - (listElement.current.clientWidth *.02))+"px";
                      }
                }}>
            <div ref={popoverMenuParent} style={{}}>
                <MenuItem onClick={()=>{handleClose()}}>
                   
                    <ListItemText primary="View products" />
                </MenuItem>
                <Divider/>
                <MenuItem onClick={()=>{handleClose()}}>
                    
                    <ListItemText primary="Seller information" />
                </MenuItem>
            </div>    
        </Popover>
        );
    }

    useEffect(() => {
        getSeller()
        
      },[isLoading]);
    function getSeller(){
        const options = {
            method: 'POST',
            url: '/SellerAccounts/getSellerAccountSeller.json'
          }
           axios(options)
             .then(res => {
                
              const isSuccess = res.data.response.is_success
              const message = res.data.response.message
              const sellers = res.data.response.sellers
              if(!isSuccess){
                alert(message)
              }else{
                setSellers(sellers);
              }
             });
    }
 
    const connectionDialog = ()=>{
        return(
            <Dialog open={openConnectionDialog} onClose={handleCloseConnectionDialog} aria-labelledby="form-dialog-title">
                
                <DialogContent>
                <DialogContentText>
                Please note that all commercial transactions are entirely between the buyer and the seller. This software only transmits information between the buyer and the seller. Any concerns related to commercial transactions must be directly communicated between the buyer and the seller.
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Enter referral code"
                    type="text"
                    fullWidth
                />
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCloseConnectionDialog} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleCloseConnectionDialog} color="primary">
                    Proceed
                </Button>
                </DialogActions>
            </Dialog>
        )
    }
    return (
        <div style={{padding:'0px',margin:'-25px'}}>
            
            <List ref={listElement}>
             {
                 sellers.map((seller,index)=>{
                    
                     return(
                         <div key={seller.Companies.name} onClick={(event)=>{itemOnClick(event)}}>
                         <ListItem key={seller}>
                         <img src={seller.Companies.image} style={{width:'5em',marginRight:'1em'}}/>   
                         <ListItemText primary={seller.Companies.name} secondary={seller.Companies.company_id}/>
                         </ListItem>
                        <Divider />
                     </div>
                     )
                 })
                
             }
             
             </List>
             {popupOver()}
             {connectionDialog()}
        </div>
    )
}

export default ConnectedSeller